import cn from 'classnames'
import React from 'react'

import { Tooltip } from 'components/uiKit/Dropdown'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { testProps } from 'utils/test/qaData'

import type {
  FieldLabelType,
  FieldLayoutParamsType,
  FieldLayoutType,
  IFieldMeta,
} from '../Field.types'
import * as s from './FieldLayout.module.scss'

interface IFieldLayoutProps {
  meta?: IFieldMeta
  label?: React.ReactNode
  info?: FieldLabelType<unknown>
  required?: boolean
  layout?: FieldLayoutType | FieldLayoutType[]
  layoutParams?: FieldLayoutParamsType
  empty?: boolean
  size?: KitSize
  name?: string
  children: React.ReactNode
}

const FieldLayout: React.FC<IFieldLayoutProps> = ({
  children,
  label,
  required,
  layout = [],
  info,
  meta,
  empty,
  size,
  name,
  layoutParams,
}) => {
  const { error, touched, user } = meta || {}
  const errorMessage = touched && error
  const layoutList: FieldLayoutType[] = Array.isArray(layout) ? layout : [layout]
  const isHorizontal = layoutList.includes('horizontal')
  const isTable = layoutList.includes('table')
  const isVertical = layoutList.includes('vertical')
  const layouts = layoutList.map((item) => s[item])
  const cnRoot = cn(s.root, size && s[size], layouts)

  if (empty) {
    return children as JSX.Element
  }

  return (
    <div className={cnRoot}>
      {user && (
        <div className={s.user} style={{ borderColor: user.color, background: `${user.color}22` }}>
          <div className={s.userName} style={{ background: user.color }}>
            {user.name}
          </div>
        </div>
      )}
      {label && (
        <label
          className={cn(s.label, { [s.required]: required })}
          style={{ flex: layoutParams?.labelFlex }}
        >
          {label}
          {info && (isHorizontal || isTable) && (
            <Tooltip overlay={info as React.ReactNode}>
              <Icon className={s.icon} name='builderTooltip' size={KitSize.S} />
            </Tooltip>
          )}
        </label>
      )}
      {info && isVertical && <div className={s.info}>{info as React.ReactNode}</div>}
      <div className={s.input} style={{ flex: layoutParams?.labelFlex }}>
        {children}
      </div>
      {Boolean(errorMessage) && (
        <div
          className={s.errors}
          {...testProps({
            el: 'error',
            name,
            label: errorMessage,
          })}
        >
          {errorMessage}
        </div>
      )}
    </div>
  )
}

export default FieldLayout
